import { useEffect } from "react";
import {
  AppBar,
  Badge,
  Stack,
  Toolbar,
  Typography,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { myProfile } from "@app/modules/my-profile/slice";
import { useRequestState } from "@app/hooks";
import { selectMyProfileState } from "@app/modules/my-profile/selector";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { AdminProfilePopup } from "./admin-profile-popup";
import { imageSource, Strings } from "@app/constants";

const TopBar = ({ activeItem, onMenuClick }: any) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const location = useLocation();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { data } = useRequestState({
    stateSelector: selectMyProfileState,
  });
  useEffect(() => {
    dispatch(myProfile());
  }, [dispatch]);

  const showSettingsBadge =
    location.pathname !== PATH_DASHBOARD.dashboard &&
    location.pathname !== PATH_DASHBOARD.requests;

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{ backgroundColor: "#fff", borderBottom: "1px solid #eee" }}
    >
      <Toolbar>
        {isMobile && (
          <IconButton onClick={onMenuClick} sx={{ mr: 2 }}>
            <Icon icon="mdi-light:menu" width={28} height={28} />
          </IconButton>
        )}
        {!isMobile && (
          <Stack direction="row" alignItems="center" justifyContent={"center"}>
            <img
              src={imageSource.kaizenMotor}
              alt="Logo"
              style={{  height: 40 }}
            />
          </Stack>
        )}

        <Stack direction="row" alignItems="flex-start" sx={{ ml: 10 }}>
          <Typography
            fontFamily={fontFamily}
            sx={{ color: "#000", fontWeight: 600 , fontSize:20}}
          >
            {activeItem}
          </Typography>
        </Stack>

        <Stack
          sx={{ marginLeft: "auto", marginRight: 5 }}
          direction="row"
          alignItems="center"
          spacing={4}
          justifyContent={"center"}
          alignSelf={"center"}
        >
          {showSettingsBadge && (
            <Badge
              variant="dot"
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
              {/* <img
                src="./assets/images/setting-icon.png"
                alt="settings"
                style={{
                  height: 32,
                  width: 32,
                  marginTop: 5,
                }}
              /> */}
            </Badge>
          )}

          <AdminProfilePopup
            userName={`${data?.firstName || ""} ${data?.lastName || ""}`}
            onEditProfile={() => {}}
            onMyOrders={() => {}}
            onLogout={() => {}}
          />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export { TopBar };
